/**
 * Sidebar Component
 * Navigation sidebar for the Sales Analysis Platform
 */

import { SignedIn, UserButton } from '@clerk/clerk-react';
import { Video, Home, Settings } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface NavItem {
  to: string;
  icon: React.ReactNode;
  label: string;
}

const navItems: NavItem[] = [
  { to: '/dashboard', icon: <Home size={20} />, label: 'Dashboard' },
  { to: '/recordings', icon: <Video size={20} />, label: 'My Recordings' },
  { to: '/settings', icon: <Settings size={20} />, label: 'Settings' },
];

export function Sidebar() {
  return (
    <aside className="w-64 h-screen bg-white border-r border-gray-200 flex flex-col">
      {/* Logo/Brand */}
      <div className="p-6 border-b border-gray-200">
        <h1 className="text-xl font-semibold text-gray-900">Framewise</h1>
        <p className="text-sm text-gray-500 mt-1">Sales Analysis</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-purple-50 text-purple-700'
                  : 'text-gray-700 hover:bg-gray-50'
              }`
            }
          >
            {item.icon}
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-gray-200">
        <SignedIn>
          <div className="flex items-center gap-3 px-2 py-2">
            <UserButton
              afterSignOutUrl="/login"
              appearance={{
                elements: {
                  avatarBox: 'w-10 h-10',
                },
              }}
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                My Account
              </p>
              <p className="text-xs text-gray-500 truncate">
                View profile
              </p>
            </div>
          </div>
        </SignedIn>
      </div>
    </aside>
  );
}
